import { IThrottle } from "./types";
import _ from "lodash";

export const throttle: IThrottle = _.throttle;
